
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL_API = process.env.REACT_APP_BASE_URL_API;
export const APP_VERSION = process.env.REACT_APP_VERSION;

